import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/domain-validation.svg'


const _hoisted_1 = { class: "container py-3" }
const _hoisted_2 = { class: "breadcrumb-voucher py-3" }
const _hoisted_3 = { "aria-label": "breadcrumb" }
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = { class: "breadcrumb-item" }
const _hoisted_6 = { class: "breadcrumb-item" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { class: "row pt-5" }
const _hoisted_9 = { class: "col-12 col-lg-7 d-flex flex-column justify-content-start" }
const _hoisted_10 = { class: "text-start fs-6" }
const _hoisted_11 = { class: "text-start mb-4" }
const _hoisted_12 = { class: "text-start mb-4" }
const _hoisted_13 = { class: "text-start" }
const _hoisted_14 = { class: "fst-italic fw-500" }
const _hoisted_15 = { class: "fst-italic fw-500" }
const _hoisted_16 = { class: "gray-space" }
const _hoisted_17 = { class: "text" }
const _hoisted_18 = { class: "text-start mb-4" }
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = { class: "fst-italic fw-500" }
const _hoisted_21 = { class: "gray-space mb-3" }
const _hoisted_22 = { class: "text" }
const _hoisted_23 = {
  class: "alert alert-dismissible alert-warning",
  role: "alert"
}
const _hoisted_24 = { class: "alert__icon" }
const _hoisted_25 = {
  class: "alert alert-dismissible",
  role: "alert"
}
const _hoisted_26 = { class: "alert__icon" }
const _hoisted_27 = { class: "text-start" }
const _hoisted_28 = { class: "d-flex flex-column gap-4" }
const _hoisted_29 = {
  id: "modal-await-button",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal-await"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Wizzard = _resolveComponent("Wizzard")!
  const _component_Contact = _resolveComponent("Contact")!
  const _component_ModalAwaitVue = _resolveComponent("ModalAwaitVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ol", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  class: "color--info",
                  name: "house"
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: "color--info",
              to: "/"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" Emissão de Certificado ")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: "color--primary disabled fw-600",
              to: "/"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" Certificado SSL ")
              ])),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_Wizzard, { "current-page": "alldone" }),
    _cache[22] || (_cache[22] = _createElementVNode("h2", { class: "w-100 fw-600 text-start mt-5" }, " Pra terminar, vamos validar seu domínio ", -1)),
    _createElementVNode("div", _hoisted_8, [
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "d-none d-lg-block col-lg-5 d-flex justify-content-center" }, [
        _createElementVNode("img", {
          id: "domain-validation-image",
          src: _imports_0,
          alt: "domain-validation"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_router_link, {
          to: "/domain-validation/validation",
          class: "text-start text link-info"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, { name: "angle-left" }),
            _cache[4] || (_cache[4] = _createTextVNode(" Escolher outro tipo de validação "))
          ]),
          _: 1
        }),
        _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "fs-5 fw-400 text-start mt-3 mb-4" }, " Validação de domínio via HTTP ", -1)),
        _createElementVNode("p", _hoisted_10, [
          _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Domínio:", -1)),
          _createTextVNode(" www." + _toDisplayString(_ctx.domain), 1)
        ]),
        _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-start" }, " Para completar a validação de controle de domínio para este certificado, siga as instruções abaixo: ", -1)),
        _createElementVNode("div", _hoisted_11, [
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-start" }, "1. Faça o download do arquivo de validação", -1)),
          _createElementVNode("button", {
            class: "btn btn-info btn-sm",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadValidationFile && _ctx.downloadValidationFile(...args)))
          }, [
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "me-2" }, "Baixar arquivo de validação", -1)),
            _createVNode(_component_Icon, { name: "download" })
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("p", _hoisted_13, [
            _cache[8] || (_cache[8] = _createTextVNode(" 2. Crie a pasta ")),
            _createElementVNode("span", _hoisted_14, "\"" + _toDisplayString(_ctx.firstFolder) + "”", 1),
            _cache[9] || (_cache[9] = _createTextVNode(" e, dentro dela, crie outra pasta ")),
            _createElementVNode("span", _hoisted_15, "\"" + _toDisplayString(_ctx.secondFolder) + "”", 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "fw-500" }, "Exemplo:", -1)),
              _createTextVNode(" www." + _toDisplayString(_ctx.domain) + "/" + _toDisplayString(_ctx.firstFolder) + "/" + _toDisplayString(_ctx.secondFolder), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("p", _hoisted_19, [
            _cache[11] || (_cache[11] = _createTextVNode(" 3. Faça upload do arquivo de validação dentro da pasta ")),
            _createElementVNode("span", _hoisted_20, "\"" + _toDisplayString(_ctx.secondFolder) + "”", 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("span", _hoisted_22, [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "fw-500" }, "Exemplo:", -1)),
              _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.links[0]) + " ", 1),
              _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.links[1]), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_Icon, { name: "circle-exclamation" })
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "alert__content" }, [
              _createElementVNode("span", { class: "text" }, " Importante: o nome e o conteúdo do arquivo não devem ser alterados. ")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_Icon, { name: "lightbulb" })
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "alert__content" }, [
              _createElementVNode("span", { class: "text" }, " Depois que o domínio estiver validado, você poderá deletar as pastas! ")
            ], -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-start" }, " 4. Após finalizar os passos acima, clique no botão abaixo para iniciar a validação do domínio. ", -1)),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              id: "validate-domain-button",
              class: "btn btn-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validateDomain && _ctx.validateDomain(...args)))
            }, [
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "me-2" }, "Validar domínio", -1)),
              _createVNode(_component_Icon, { name: "globe" })
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Contact),
    _createVNode(_component_ModalAwaitVue),
    _withDirectives(_createElementVNode("button", _hoisted_29, null, 512), [
      [_vShow, false]
    ])
  ]))
}